export default __webpack_public_path__ + "static/media/Log.a03c5745.png";